import memoizeOne, { type MemoizedFn } from 'memoize-one';

export const eventCpusPlugin: MemoizedFn<
	() => {
		'event:cpus': number;
	} | null
> = memoizeOne(
	(): {
		'event:cpus': number;
	} | null => {
		if (!navigator.hardwareConcurrency) {
			return null;
		}
		return {
			'event:cpus': navigator.hardwareConcurrency,
		};
	},
);
